import { OneEvent } from '../../common';
import { MODE } from '../../constants';

const PreMatchOneEvent = ({ id }) => (
  <OneEvent id={id} serviceId={MODE.PRE_MATCH} />
);

export default PreMatchOneEvent;
